export default __webpack_public_path__ + "static/media/TitilliumWeb-ExtraLightItalic.94defa8e.ttf";